import { render, staticRenderFns } from "./SimiliarityCheck.vue?vue&type=template&id=5a8cf8aa&"
import script from "./SimiliarityCheck.vue?vue&type=script&lang=js&"
export * from "./SimiliarityCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports